import { render } from "./LoyaltySteps.vue?vue&type=template&id=5ec3b352&scoped=true"
import script from "./LoyaltySteps.vue?vue&type=script&lang=js"
export * from "./LoyaltySteps.vue?vue&type=script&lang=js"

import "./LoyaltySteps.vue?vue&type=style&index=0&id=5ec3b352&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec3b352"]])

export default __exports__